import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=60acf05d&scoped=true&"
import script from "./screenshot.vue?vue&type=script&lang=js&"
export * from "./screenshot.vue?vue&type=script&lang=js&"
import style0 from "./screenshot.vue?vue&type=style&index=0&id=60acf05d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acf05d",
  null
  
)

export default component.exports